import { render, staticRenderFns } from "./updateRequirement.vue?vue&type=template&id=4ed3535a&"
import script from "./updateRequirement.vue?vue&type=script&lang=ts&"
export * from "./updateRequirement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports